import React from 'react';
import { motion } from 'framer-motion';
export function ImagineSection() {
  const imagineItems = ['Imagina despertar cada mañana con más tranquilidad y menos preocupación.', 'Sentir que tu fe es más fuerte que tus miedos.', 'Aprender a reconocer la mano de Dios incluso en los pequeños detalles de tu día.', 'Volver a experimentar gratitud, esperanza y confianza, aun cuando todavía existan desafíos.', 'Y, sobre todo, recuperar la certeza de que no estás caminando sola, porque Dios está guiando cada uno de tus pasos.'];
  return <section className="w-full bg-[#4A331A] py-20 px-6 relative overflow-hidden" data-id="element-153" data-mp="sovs8cb8qlq9">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(224,183,86,0.14)_0%,_transparent_55%)]" data-id="element-154" data-mp="dvirb0740z2t"></div>

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-155" data-mp="287pe6w9d94ay">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl font-bold uppercase tracking-wide text-[#E0B756] text-center mb-12 leading-snug" data-id="element-156" data-mp="2890egm3lrtxb">
          La buena noticia es que no tiene por qué seguir siendo así
        </motion.h2>

        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-300" data-id="element-157" data-mp="mov90fsy209p">
          {imagineItems.map((item, index) => <motion.p key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={index === imagineItems.length - 1 ? 'text-white font-semibold' : ''} style={{
          color: "#F7F2E7"
        }} data-id="element-158" data-mp="3q3qwto4n2zb0" data-mpi={index}>
              {item}
            </motion.p>)}
        </div>
      </div>
    </section>;
}